export const TEACHING_WORKLOAD = '/teaching_workload/' as const
export const TEACHING_WORKLOAD_APPROVAL_ALL = `${TEACHING_WORKLOAD}approval/all` as const
export const TEACHING_WORKLOAD_APPROVAL_BY_ID = `${TEACHING_WORKLOAD}approval/` as const
export const TEACHING_WORKLOAD_APPROVAL_SUBMIT = `${TEACHING_WORKLOAD}approval/submit` as const
export const TEACHING_WORKLOAD_APPROVAL_RESPONSE = `${TEACHING_WORKLOAD}approval/response` as const
export const TEACHING_WORKLOAD_REPORT_BULK = `${TEACHING_WORKLOAD}report/bulk` as const
export const TEACHING_WORKLOAD_REPORT_SINGLE = `${TEACHING_WORKLOAD}report/single` as const
